import React, { useEffect, useRef, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClearTokenRedirectLogin } from 'utils/general';
import EditIcon from 'assets/images/Dashboard/edit-profile.svg';
import CommonModal from 'components/commom/Modal';
import CloseIcon from 'assets/images/Dashboard/close-profile.svg';
import ReusableButton from 'components/commom/Button';
import { updateProfileSectionData } from 'store/updateDoctorProfile/updateDotorProfileAction';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import DocumentIcon from 'assets/images/Dashboard/document-text-profile.svg';
import LocationIcon from 'assets/images/Dashboard/location-profile.svg';
import SelectInput from 'components/commom/SelectInput';
import { getPracticeList } from 'store/registerPractice/registePracticeAction';
import LabelWithInput from 'components/commom/LabelWithInput';
import InputAdornment from '@mui/material/InputAdornment';
import { registerUsers } from 'store/register/registerAction';
import { registerUploadAction } from 'store/registerUpload/registerUploadAction';
import UploadIconList from 'assets/images/WithoutLogin/upload-list.svg';
import { registerProfessionalPost } from 'store/registerProfessional/registerProfessionalAction';
import LocalStorageManager from 'managers/LocalStorageManger';
import CommonToast from 'components/commom/CommonToast';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { updateSubpracticeInfoCallAPI } from 'store/updateSubpracticeInfo/action';

const AboutTab = ({ getUpdateValue }) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const brandImageFileInputRef = useRef([]);
  const [bioModal, setBioModal] = useState(false);
  const [professionalModal, setProfessionalModal] = useState(false);
  const [subListId, setsubListId] = useState([]);
  const [subListPrev, setSubListPrev] = useState([]);
  const [viewData, setViewData] = useState({});
  const [feeModal, setFeeModal] = useState(false);
  const [fee, setFee] = useState(0);

  const providerData = useSelector(
    (state) => state?.getPracticeReducer?.users?.data
  );

  const aboutValue = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const registerUserReducer = useSelector(
    (state) => state?.registerUserReducer?.users?.data
  );

  const bioUpdateReducer = useSelector(
    (state) => state?.updateProfileSectionDataReducer?.loading
  );

  const subpracticeInfoLoader = useSelector(
    (state) => state?.updateSubpracticeInfoReducer?.loading
  );

  useEffect(() => {
    dispatch(registerUsers(aboutValue?.address?.country?.id));
  }, []);

  useEffect(() => {
    setFormData(providerData?.[0]);
    setId(providerData?.[0]?.id);
  }, [providerData]);

  const [formData, setFormData] = useState(providerData?.[0]);
  const [id, setId] = useState(providerData?.[0]?.id ?? '');

  useEffect(() => {
    setShowBioValue(aboutValue?.bio);
  }, [aboutValue]);

  const [bioText, setBioText] = useState(
    aboutValue?.bio !== null ? aboutValue?.bio : ''
  );
  const [showBioValue, setShowBioValue] = useState(aboutValue?.bio);
  const [copied, setCopied] = useState(false);

  const handleBioModal = () => {
    setBioModal(true);
  };

  const handleCloseBio = () => {
    setBioModal(false);
  };

  const handleSaveBio = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setBioModal(false);
        getUpdateValue(true);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
        getUpdateValue(false);
      },
    };
    let body = {
      bio: bioText,
    };
    dispatch(updateProfileSectionData(external, body));
  };

  useEffect(() => {
    getPracticeData();
  }, []);

  const getPracticeData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(getPracticeList(external));
  };

  const handleCloseProfessional = () => {
    setProfessionalModal(false);
  };

  const handleChange = (event) => {
    setFormData(event?.target?.value);
    setsubListId([]);
    setId(event?.target?.value?.id);
  };

  const handleSelectPractice = (value) => {
    let arr = [...subListId];
    let arrList = [...subListPrev];
    if (arr.includes(value.id)) {
      let index = arr.findIndex((item) => item === value.id);
      let indexList = arrList.findIndex((item) => item === value);
      arr.splice(index, 1);
      arrList.splice(indexList, 1);
      setsubListId(arr);
      setSubListPrev(arrList);
    } else {
      arr.push(value.id);
      arrList.push({
        sub_practice_id: value?.id,
        state_code_id: '',
        state_license_id: '',
        fee_per_session: '',
        doctor_practice_id: id,
        code: '',
        state_license: '',
      });
      setsubListId(arr);
      setSubListPrev(arrList);
    }
  };

  const handleInputChange = (event, name, index) => {
    const updatedDetails = [...subListPrev];
    updatedDetails[index].fee_per_session = event?.target?.value;
    setSubListPrev(updatedDetails);
  };

  const handleStateChange = (event, name, index) => {
    const { value } = event?.target;
    const updatedDetails = [...subListPrev];
    updatedDetails[index].code = value?.code;
    updatedDetails[index].state_code_id = value?.id;
    setSubListPrev(updatedDetails);
  };

  const handleBrandImageUpload = (index) => {
    brandImageFileInputRef.current[index]?.click();
  };

  const handleBrandImageFileChange = (e, index) => {
    const file = e.target.files?.[0]?.name;
    let Data = new FormData();
    Data.append('filePath', file);

    const external = {
      run: true,
      handleFunction: (res) => {
        const filePath = res?.data?.[0]?.filePath;
        const fileName = filePath ? filePath.split('/').pop() : null;

        const updatedDetails = [...subListPrev];
        updatedDetails[index].state_license = fileName;
        updatedDetails[index].state_license_id = res?.data?.[0]?.id;
        setSubListPrev(updatedDetails);

        showToast(res?.message, 'success');
      },
      error: true,
      handleErrorFunction: (res) => showToast(res?.message, 'error'),
    };

    dispatch(registerUploadAction(Data, external));
  };

  const handleSaveProfessional = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = subListPrev;

    dispatch(
      registerProfessionalPost(
        body,
        LocalStorageManager.getItem('doctorId'),
        external
      )
    );
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(aboutValue.appointment_link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
    });
  };

  const handleEditData = (data) => {
    setViewData(data);
    setFeeModal(true);
    setFee(data?.fee_per_session);
  };

  const handleFeeSave = () => {
    const data = {
      detail: {
        fee_per_session: fee,
      },
      doctor_id: aboutValue?.id,
      doc_subpractice_id: viewData?.id,
    };

    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setFeeModal(false);
        getUpdateValue(true);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    dispatch(updateSubpracticeInfoCallAPI(data, external));
  };

  return (
    <>
      {aboutValue?.title?.slug !== 'aesthetician' &&
        aboutValue?.subscription?.is_active &&
        aboutValue?.subscription?.subscribed_id && (
          <div className="pt-16">
            <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7">
              <Col sm={12} className="p-0">
                <Stack direction="horizontal" className="flex justify-between">
                  <div className="fs-18 lh-27 family_outfit_bold_700 fc-202224">
                    Appointment Link
                  </div>
                </Stack>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-8 fc-A2A2A2 lh-24 fs-16 family_outfit_regular_400 flex items-center">
                  <a className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 flex">
                    Make it easy for patients to find you. Share your profile
                    link on social media.
                  </a>
                  <button
                    onClick={handleCopy}
                    className="inline-flex items-center p-2 rounded-full hover:bg-gray-100"
                    title="Copy profile link"
                  >
                    <ContentCopyIcon fontSize="small" />
                  </button>
                  {copied && (
                    <span className="ml-2 text-green-600 text-sm">Copied!</span>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        )}
      <div className="pt-16">
        <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7">
          <Col sm={12} className="p-0">
            <Stack direction="horizontal" className="flex justify-between">
              <div className="fs-18 lh-27 family_outfit_bold_700 fc-202224">
                Bio
              </div>
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center cursor-pointer ..."
                onClick={() => handleBioModal()}
              >
                <div>
                  <Image src={EditIcon} alt="icon" />
                </div>
                <div className="fs-16 lh-20 fc-C56616 family_outfit_semiBold_600">
                  Edit Bio
                </div>
              </Stack>
            </Stack>
          </Col>
          <Col md={12} className="p-0">
            <div className="pt-8 fc-A2A2A2 lh-24 fs-16 family_outfit_regular_400">
              {showBioValue}
            </div>
          </Col>
        </Row>
      </div>

      <div className="pt-16">
        <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7">
          <Col sm={12} className="p-0">
            <Stack
              direction="horizontal"
              className="flex justify-between pb-12"
            >
              <div className="fs-18 lh-27 family_outfit_bold_700 fc-202224">
                Professional Details
              </div>
            </Stack>
          </Col>
          {aboutValue?.professional_details &&
            aboutValue?.professional_details.length > 0 &&
            aboutValue?.professional_details.map((item, index) => {
              return (
                <>
                  {item?.doctor_sub_practice_info &&
                    item?.doctor_sub_practice_info.length > 0 &&
                    item?.doctor_sub_practice_info.map((aitem, index) => {
                      return (
                        <>
                          <Col sm={12} md={6} className="p-0">
                            <div className="p-12 border border-custom-gray mr-10">
                              <div className="fs-16 fc-292D32 lh-201 family_outfit_semiBold_600">
                                {item?.practice_name}
                              </div>
                              <div className="pt-04 fs-14 fc-A4AAB2 lh-176 family_outfit_regular_400">
                                {aitem?.sub_practice}
                              </div>
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="items-center pt-12"
                              >
                                <div>
                                  <Image src={DocumentIcon} alt="icon" />
                                </div>
                                <div className="fs-14 fc-A4AAB2 lh-176 family_outfit_regular_400">
                                  <a
                                    href={aitem?.state_license || '#'}
                                    download={
                                      aitem?.state_license
                                        ? aitem?.state_license.split('/').pop()
                                        : 'license'
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="fs-14 fc-A4AAB2 lh-176 family_outfit_regular_400 cursor-pointer underline underline-offset-4"
                                  >
                                    {aitem?.state_license &&
                                      aitem?.state_license.split('/').pop()}
                                  </a>
                                </div>
                              </Stack>
                              <Stack
                                direction="horizontal"
                                gap={2}
                                className="flex justify-between pt-12"
                              >
                                <Stack direction="horizontal" gap={2}>
                                  <div>
                                    <Image src={LocationIcon} alt="icon" />
                                  </div>
                                  <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                                    {aitem?.state_code?.name}
                                  </div>
                                </Stack>
                                <Stack direction="horizontal" gap={2}>
                                  <div className="fs-18 fc-202224 lh-2268  family_outfit_medium_500">
                                    $
                                  </div>
                                  <div className="fs-18 fc-202224 lh-2268  family_outfit_medium_500">
                                    {aitem?.fee_per_session}/session
                                  </div>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => handleEditData(aitem)}
                                  >
                                    <Image src={EditIcon} alt="icon" />
                                  </div>
                                </Stack>
                              </Stack>
                            </div>
                          </Col>
                        </>
                      );
                    })}
                </>
              );
            })}
        </Row>
      </div>

      <CommonModal
        padding={'24px'}
        width={'680px'}
        modalActive={bioModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="flex justify-between">
                  <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Bio" />
                  </div>
                  <div>
                    <Image
                      src={CloseIcon}
                      alt="icon"
                      className="cursor-pointer ..."
                      onClick={() => handleCloseBio()}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-40">
                  <LabelWithTextArea
                    placeholder={intl.formatMessage({ id: 'Write here...' })}
                    height="100"
                    multiline
                    name="bio"
                    Color={'#212426'}
                    padding={'8px'}
                    value={bioText}
                    onChange={(e) => setBioText(e?.target?.value)}
                  />
                </div>
              </Col>

              <Col md={12} className="p-0">
                <div className="pt-40 flex justify-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor=" #375241"
                    brColor="transparent"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !bioUpdateReducer && handleSaveBio();
                    }}
                    loading={bioUpdateReducer}
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </div>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'680px'}
        modalActive={professionalModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="flex justify-between">
                  <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Professional Details" />
                  </div>
                  <div>
                    <Image
                      src={CloseIcon}
                      alt="icon"
                      className="cursor-pointer ..."
                      onClick={() => handleCloseProfessional()}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-40">
                  <SelectInput
                    label="Practice Name"
                    placeholder={intl.formatMessage({
                      id: 'Practice Name',
                    })}
                    name={'practiceName'}
                    value={formData?.practice_name}
                    data={providerData}
                    onChange={(e) => handleChange(e, 'practiceName')}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="fs-16 family_outfit_medium_500 lh-201 fc-292D32 pt-16">
                  Select sub-practices
                </div>
                <div className="flex flex-wrap">
                  {formData?.sub_practice_info &&
                    formData?.sub_practice_info?.length > 0 &&
                    formData?.sub_practice_info.map((item, index) => {
                      return (
                        <div
                          className="practice-box mr-2"
                          onClick={() => handleSelectPractice(item)}
                          style={{
                            border: subListId.includes(item?.id)
                              ? '1px solid #864629'
                              : '1px solid #EFE3D7',
                            background:
                              subListId.includes(item?.id) && '#FEF9F6',
                          }}
                        >
                          <div
                            className="fs-14 family_outfit_regular_400 lh-176"
                            style={{
                              color: subListId.includes(item?.id)
                                ? '#864629 '
                                : '#3C3C3C',
                            }}
                          >
                            {item?.name}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </Col>
              {subListPrev &&
                subListPrev.length > 0 &&
                subListPrev.map((item, index) => {
                  return (
                    <>
                      <Col md={6} className="p-0">
                        <div
                          className="d-flex flex-column pt-16"
                          style={{ borderBottom: '1px solid #efe3d7' }}
                        >
                          <label
                            className="fs-14 family_outfit_medium_500 mb-2 fc-292D32"
                            htmlFor={`file-upload-${index}`}
                          >
                            Qualification Document
                          </label>

                          <div className="d-flex pb-3">
                            <input
                              id={`file-upload-${index}`}
                              ref={(el) =>
                                (brandImageFileInputRef.current[index] = el)
                              }
                              type="file"
                              accept=".png, .jpg, .jpeg, .gif, .mp4, .pdf"
                              disabled={false}
                              style={{ display: 'none' }}
                              onChange={(e) =>
                                handleBrandImageFileChange(e, index)
                              }
                            />
                            <label
                              className="cursor-pointer d-flex align-items-center"
                              htmlFor={`file-upload-${index}`}
                            >
                              {item?.state_license ? (
                                <div className="pl-8 pt-0.5 fs-14 lh-176 fc-5B88E9 family_outfit_medium_500 underline decoration-1 truncate max-w-xs">
                                  {item?.state_license}
                                </div>
                              ) : (
                                <div className="d-flex">
                                  <div>
                                    <img
                                      src={UploadIconList}
                                      alt="Upload Icon"
                                    />
                                  </div>
                                  <div className="pl-8 pt-0.5 fs-14 lh-176 fc-C56616 family_outfit_medium_500 underline decoration-1 ...">
                                    Upload file
                                  </div>
                                </div>
                              )}
                            </label>
                          </div>
                        </div>
                      </Col>
                      <Col md={6} className="modal-size">
                        <div className="pt-16">
                          <LabelWithInput
                            label="Fee per session"
                            placeholder="Fee per session"
                            name="fee_per_session"
                            type="text"
                            value={item?.fee_per_session}
                            onChange={(e) =>
                              handleInputChange(e, 'fee_per_session', index)
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div className="fs-18 lh-18 fc-202224 family_outfit_regular_400 pt-1">
                                    $
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={12} className="p-0">
                        <div className="pt-16">
                          <SelectInput
                            label={'stateCode'}
                            placeholder={intl.formatMessage({
                              id: 'State Code',
                            })}
                            name="code"
                            value={item?.code}
                            data={registerUserReducer}
                            onChange={(e) =>
                              handleStateChange(e, 'code', index)
                            }
                          />
                        </div>
                      </Col>
                    </>
                  );
                })}
              {subListPrev && subListPrev.length > 0 && (
                <Col md={12} className="p-0">
                  <div className="pt-40 flex justify-center">
                    <ReusableButton
                      fullWidth={false}
                      variant="outlined"
                      color="#F5F5F5"
                      fontSize="16px"
                      fontWeight="500"
                      padding="14px 55px"
                      height="44px"
                      bgColor=" #375241"
                      brColor="transparent"
                      fontFamily="outfit_medium"
                      onClick={() => handleSaveProfessional()}
                    >
                      <FormattedMessage id="Save" />
                    </ReusableButton>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'680px'}
        modalActive={feeModal}
        innerContent={
          <div className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col md={12} className="p-0 m-0">
                <div className="flex justify-between">
                  <div className="fs-24 lh-3024 fc-292D32 family_outfit_semiBold_600">
                    <FormattedMessage id="Fee per session" />
                  </div>
                  <div>
                    <Image
                      src={CloseIcon}
                      alt="icon"
                      className="cursor-pointer ..."
                      onClick={() => {
                        setViewData({});
                        setFeeModal(false);
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-40">
                  <LabelWithInput
                    label="Fee per session"
                    placeholder="Fee per session"
                    name="fee"
                    type="number"
                    value={fee}
                    onChange={(e) => {
                      setFee(e.target.value);
                    }}
                  />
                </div>
              </Col>

              <Col md={12} className="p-0">
                <div className="pt-40 flex justify-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor=" #375241"
                    brColor="transparent"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !subpracticeInfoLoader && handleFeeSave();
                    }}
                    loading={subpracticeInfoLoader}
                  >
                    <FormattedMessage id="Save" />
                  </ReusableButton>
                </div>
              </Col>
            </Row>
          </div>
        }
      />
    </>
  );
};

export default AboutTab;
